export default __webpack_public_path__ + "static/media/suliac-room2-min.03121f9f.jpg";